import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import { apiBaseURL } from "../config/api";

axios.defaults.baseURL = apiBaseURL;
Vue.use(VueAxios, axios);
